import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { ReturnStruct } from '../../structs/return.struct';

export interface ImportacaoInventarioItemValidacao {
  status: number; // 0=válido, 1=aviso, 2=erro, 3=não conferido
  mensagem?: string;
  idProduto?: number;
  nomeProduto?: string;
  codigoSku?: string;
  gtinEan?: string;
  idLocalizacaoEstoque: number;
  nomeLocalizacao: string;
  saldoSistema: number;
  saldoContado: number;
  ajuste: number;
  custoMedio: number;
  isControlaLotes: boolean;
  isControlaSeries: boolean;
  linhaBruta?: string;
  numeroLinha: number;
}

export interface ImportacaoInventarioValidacaoResponse extends ReturnStruct {
  totalValidos: number;
  totalAvisos: number;
  totalErros: number;
  totalNaoConferidos: number;
  itens: ImportacaoInventarioItemValidacao[];
}

export interface ConfirmarImportacaoInventarioResponse extends ReturnStruct {
  idInventario?: number;
}

export interface ImportacaoInventarioItemConfirmar {
  idProduto: number;
  nomeProduto: string;
  codigoSku?: string;
  gtinEan?: string;
  idLocalizacaoEstoque: number;
  nomeLocalizacao: string;
  saldoSistema: number;
  saldoContado: number;
  custoMedio: number;
  isControlaLotes: boolean;
  isControlaSeries: boolean;
}

export interface ValidarPlanilhaRequest {
  arquivoBase64: string;
  idLocalizacaoEstoqueDefault?: number;
  nomeLocalizacaoDefault?: string;
  modoProcessamento?: number; // 0=apenas arquivo, 1=todos
}

export interface ConfirmarPlanilhaRequest {
  descricao: string;
  observacao?: string;
  idLocalizacaoEstoqueDefault: number;
  nomeLocalizacaoDefault: string;
  modoProcessamento?: number;
  itens: ImportacaoInventarioItemConfirmar[];
}

export interface ValidarColetorRequest {
  arquivoBase64: string;
  separador: string;
  linhaInicio: number;
  tipoValidacao: number; // 0=GTIN, 1=SKU, 2=Ambos
  idLocalizacaoEstoque: number;
  nomeLocalizacao: string;
  modoProcessamento: number; // 0=apenas arquivo, 1=todos
}

export interface ConfirmarColetorRequest {
  descricao: string;
  observacao?: string;
  idLocalizacaoEstoque: number;
  nomeLocalizacao: string;
  modoProcessamento: number;
  itens: ImportacaoInventarioItemConfirmar[];
}

@Injectable({ providedIn: 'root' })
export class InventarioImportacaoService extends CommonService {
  private readonly apiUrl: string = environment.urlApiOrquestradorSuprimentos + 'InventarioImportacaoOrquestrador';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public validarPlanilha(request: ValidarPlanilhaRequest): Observable<ImportacaoInventarioValidacaoResponse> {
    return this.httpClient
      .post<ImportacaoInventarioValidacaoResponse>(`${this.apiUrl}/planilha/validar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public confirmarPlanilha(request: ConfirmarPlanilhaRequest): Observable<ConfirmarImportacaoInventarioResponse> {
    return this.httpClient
      .post<ConfirmarImportacaoInventarioResponse>(`${this.apiUrl}/planilha/confirmar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public downloadPlanilhaModelo(): Observable<Blob> {
    return this.httpClient
      .get(`${this.apiUrl}/planilha/modelo`, { ...this.addHeaderToken(), responseType: 'blob' })
      .pipe(catchError(this.handleError));
  }

  public validarColetor(request: ValidarColetorRequest): Observable<ImportacaoInventarioValidacaoResponse> {
    return this.httpClient
      .post<ImportacaoInventarioValidacaoResponse>(`${this.apiUrl}/coletor/validar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public confirmarColetor(request: ConfirmarColetorRequest): Observable<ConfirmarImportacaoInventarioResponse> {
    return this.httpClient
      .post<ConfirmarImportacaoInventarioResponse>(`${this.apiUrl}/coletor/confirmar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public downloadColetorModelo(): Observable<Blob> {
    return this.httpClient
      .get(`${this.apiUrl}/coletor/modelo`, { ...this.addHeaderToken(), responseType: 'blob' })
      .pipe(catchError(this.handleError));
  }
}
